import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, 
  BookOpen, 
  Briefcase, 
  Brain, 
  BarChart3, 
  Users, 
  Settings,
  GraduationCap,
  UserCheck,
  TrendingUp,
  FileText,
  Target
} from 'lucide-react';
import useAuthStore from '../../store/authStore';

const Sidebar = () => {
  const { user } = useAuthStore();
  const userType = user?.user_type || 'learner';

  const getNavigationItems = () => {
    switch (userType) {
      case 'learner':
        return [
          { name: 'Dashboard', href: '/learner/dashboard', icon: Home },
          { name: 'Courses', href: '/learner/courses', icon: BookOpen },
          { name: 'Jobs', href: '/learner/jobs', icon: Briefcase },
          { name: 'Skills', href: '/learner/skills', icon: Brain },
          
        ];
      case 'trainer':
        return [
          { name: 'Dashboard', href: '/trainer/dashboard', icon: Home },
          { name: 'My Courses', href: '/trainer/courses', icon: BookOpen },
          { name: 'Analytics', href: '/trainer/analytics', icon: BarChart3 },
          { name: 'Students', href: '/trainer/students', icon: Users },
        ];
      case 'policymaker':
        return [
          { name: 'Dashboard', href: '/policymaker/dashboard', icon: Home },
          { name: 'Analytics', href: '/policymaker/analytics', icon: BarChart3 },
          { name: 'Skills Gap', href: '/policymaker/skills-gap', icon: Target },
          { name: 'Reports', href: '/policymaker/reports', icon: FileText },
        ];
      default:
        return [];
    }
  };

  const commonItems = [
    { name: 'Profile', href: '/profile', icon: Settings },
  ];

  const navigationItems = [...getNavigationItems(), ...commonItems];

  return (
    <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 lg:z-50">
      <div className="flex flex-col flex-grow bg-white border-r border-gray-200 pt-5 pb-4 overflow-y-auto">
        {/* Logo */}
        <div className="flex items-center flex-shrink-0 px-4">
          <div className="flex items-center">
            <div className="h-8 w-8 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-lg flex items-center justify-center">
              <GraduationCap className="h-5 w-5 text-white" />
            </div>
            <div className="ml-3">
              <h1 className="text-xl font-bold text-gray-900">SkillMarg</h1>
              <p className="text-xs text-gray-500">AI-Powered Learning</p>
            </div>
          </div>
        </div>

        {/* User info */}
        <div className="mt-6 px-4">
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center">
              <UserCheck className="h-6 w-6 text-primary-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700">
                {user?.first_name} {user?.last_name}
              </p>
              <p className="text-xs text-gray-500 capitalize">
                {userType}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="mt-8 flex-1 px-2 space-y-1">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.name}
                to={item.href}
                end={item.name === 'Dashboard'}
                className={({ isActive }) =>
                  `group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                    isActive
                      ? 'bg-primary-100 text-primary-900 border-r-2 border-primary-600'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      className={`mr-3 h-5 w-5 flex-shrink-0 ${
                        isActive
                          ? 'text-primary-600'
                          : 'text-gray-400 group-hover:text-gray-500'
                      }`}
                    />
                    {item.name}
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="flex-shrink-0 px-4 py-4">
          <div className="bg-gradient-to-r from-primary-50 to-secondary-50 rounded-lg p-3">
            <div className="flex items-center">
              <TrendingUp className="h-5 w-5 text-primary-600" />
              <div className="ml-2">
                <p className="text-xs font-medium text-gray-900">AI Insights</p>
                <p className="text-xs text-gray-600">Powered by MiniMax-M2</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;